



// 消息符号——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `icon/message/index${i + 1}`,
  name: `icon/messageIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/message/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 消息符号——主流程，开始
    ...MainRoutes,
  ],
};
